export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',

  // 商品管理模块
  'menu.products': '商品管理',
  'menu.products.list': '商品列表',
  'menu.products.detail': '商品详情',
  'menu.products.create': '新增商品',
  'menu.products.edit': '编辑商品',

  // 仓库管理模块
  'menu.warehouses': '仓库管理',
  'menu.warehouses.list': '仓库列表',
  'menu.warehouses.detail': '仓库详情',
  'menu.warehouses.create': '新增仓库',
  'menu.warehouses.edit': '编辑仓库',

  // 库存管理模块
  'menu.inventory': '库存管理',
  'menu.inventory.list': '库存列表',
  'menu.inventory.detail': '库存详情',
  'menu.inventory.create': '新增库存',
  'menu.inventory.edit': '编辑库存',

  // 订单管理模块
  'menu.orders': '订单管理',
  'menu.orders.list': '订单列表',
  'menu.orders.detail': '订单详情',
  'menu.orders.statistics': '订单统计',

  // Amazon SP-API 集成模块
  'menu.amazon': 'Amazon',
  'menu.amazon.dashboard': '概览面板',
  'menu.amazon.credentials': '凭据管理',
  'menu.amazon.credentials.list': '凭据列表',
  'menu.amazon.credentials.create': '创建凭据',
  'menu.amazon.credentials.edit': '编辑凭据',
  'menu.amazon.credentials.detail': '凭据详情',
  'menu.amazon.orders-sync': '订单同步',
  'menu.amazon.sync': '同步管理',
  'menu.amazon.sync.status': '同步状态',
  'menu.amazon.sync.errors': '同步错误',
  'menu.amazon.sync.history': '同步历史',
  'menu.amazon.monitoring': '监控统计',
  'menu.amazon.monitoring.overview': '监控概览',
  'menu.amazon.monitoring.api-usage': 'API使用',
  'menu.amazon.monitoring.performance': '性能监控',
  'menu.amazon.monitoring.alerts': '告警管理',

  // 临时修复重复键名问题
  'menu.amazon.amazon.sync.amazon.sync.status': '同步状态',
  'menu.amazon.amazon.monitoring.amazon.monitoring.alerts': '告警管理',
};
